export const CONFIG = {
  API_URL: process.env.REACT_APP_API_URL || "https://api.ambfc.com",
  // API_URL: process.env.REACT_APP_API_URL || "https://artemis-agent-api.secure-restapi.com",
};
